/**
 * React error boundary re-export (#1241 Swappability rails).
 *
 * Re-exports `Sentry.ErrorBoundary` from `@sentry/react` so app code
 * imports `{ ErrorBoundary }` from `@/lib/errorReporter` rather than
 * touching `@sentry/*` directly. The component degrades gracefully
 * when the master toggle is off: the SDK hasn't been initialized, so
 * the boundary's child-error path still renders the fallback but
 * doesn't ship the event. That's the desired no-op behavior.
 *
 * This file lives in the adapter directory so the `@sentry/react`
 * import is grep-confined per the swappability acceptance check.
 */
import * as Sentry from '@sentry/react'

export const ErrorBoundary = Sentry.ErrorBoundary
